import { Link } from "react-router-dom";
import { LegalDoc, Section, Bullets } from "@/components/LegalDoc";
import { useSeo } from "@/lib/seo";

export default function Terms() {
  useSeo({
    title: "Termini di Servizio — StayGuide",
    description: "I termini e le condizioni d'uso della piattaforma StayGuide: account, prova gratuita, pagamenti e responsabilità.",
    path: "/termini",
  });
  return (
    <LegalDoc
      title="Termini di Servizio"
      updated="Giugno 2026"
      intro="I presenti Termini regolano l'utilizzo della piattaforma StayGuide. Utilizzando il servizio accetti integralmente queste condizioni.">
      <Section n="1" title="Accettazione dei termini">
        <p>Creando un account o utilizzando StayGuide dichiari di aver letto, compreso e accettato i presenti Termini e la <Link to="/privacy" className="text-blue-600 font-semibold">Privacy Policy</Link>.</p>
      </Section>
      <Section n="2" title="Descrizione del servizio">
        <p>StayGuide è una piattaforma che consente agli host di creare guide digitali per gli ospiti delle proprie strutture ricettive, inclusi Concierge AI, QR code, mappa e contenuti personalizzabili.</p>
      </Section>
      <Section n="3" title="Account e registrazione">
        <Bullets items={[
          "Devi fornire informazioni veritiere e mantenerle aggiornate.",
          "Sei responsabile della custodia delle credenziali e di ogni attività svolta con il tuo account.",
          "Devi avere almeno 18 anni per utilizzare il servizio.",
        ]} />
      </Section>
      <Section n="4" title="Piani, prova gratuita e pagamenti">
        <Bullets items={[
          "La prova gratuita dura 7 giorni con funzionalità e limiti indicati nella pagina prezzi.",
          "I piani a pagamento (Pro e Business) sono addebitati tramite Stripe, su base mensile o annuale.",
          "L'abbonamento si rinnova automaticamente salvo disdetta prima del rinnovo.",
          "Puoi annullare in qualsiasi momento: manterrai l'accesso fino al termine del periodo già pagato.",
          "Salvo diversa previsione di legge, i pagamenti non sono rimborsabili per i periodi già fruiti.",
        ]} />
      </Section>
      <Section n="5" title="Uso consentito">
        <p>Ti impegni a non utilizzare il servizio per scopi illeciti, a non caricare contenuti offensivi, ingannevoli o che violino diritti di terzi, e a non compromettere la sicurezza o l'integrità della piattaforma.</p>
      </Section>
      <Section n="6" title="Contenuti dell'utente">
        <p>Sei l'unico responsabile dei contenuti che inserisci nelle guide (testi, immagini, dati di contatto). Garantisci di avere i diritti necessari e sollevi StayGuide da responsabilità derivanti da tali contenuti.</p>
      </Section>
      <Section n="7" title="Proprietà intellettuale">
        <p>Il software, il marchio e il design di StayGuide sono di proprietà di <strong>Urban View Srl</strong>. I contenuti che carichi restano di tua proprietà; ci concedi una licenza limitata al solo fine di erogare il servizio.</p>
      </Section>
      <Section n="8" title="Limitazione di responsabilità">
        <p>Il servizio è fornito "così com'è". Nei limiti consentiti dalla legge, StayGuide non è responsabile per danni indiretti, perdita di dati o di profitti derivanti dall'uso del servizio. Il Concierge AI risponde in base ai contenuti forniti dall'host e potrebbe non essere sempre completo.</p>
      </Section>
      <Section n="9" title="Sospensione e cessazione">
        <p>Possiamo sospendere o chiudere account che violino i presenti Termini. Puoi cancellare il tuo account in qualsiasi momento.</p>
      </Section>
      <Section n="10" title="Legge applicabile e foro competente">
        <p>I presenti Termini sono regolati dalla legge italiana. Per ogni controversia è competente il foro di <strong>Milano</strong>, fatte salve le tutele inderogabili previste per i consumatori.</p>
      </Section>
      <Section n="11" title="Modifiche ai termini">
        <p>Potremo aggiornare i presenti Termini; le modifiche sostanziali saranno comunicate. L'uso continuato del servizio dopo le modifiche costituisce accettazione.</p>
      </Section>
      <Section n="12" title="Contatti">
        <p>Per domande sui Termini scrivi a <a href="mailto:supporto@stayguide.it" className="text-blue-600 font-semibold">supporto@stayguide.it</a>.</p>
      </Section>
    </LegalDoc>
  );
}
